import * as types from '../constants/actionTypes';

const initialState = {
  // leaderboard: { date_from, date_to, vendors: [] }
  leaderboard: null,
  // vendorScores keyed by vendorId
  vendorScores: {},
  loading: false,
  error: null,
};

const vendorPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_VENDOR_PERFORMANCE_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_ALL_VENDOR_PERFORMANCE_SUCCESS:
      return { ...state, loading: false, leaderboard: action.payload };

    case types.FETCH_ALL_VENDOR_PERFORMANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_VENDOR_PERFORMANCE_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_VENDOR_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        vendorScores: {
          ...state.vendorScores,
          [action.payload.vendorId]: action.payload.data,
        },
      };

    case types.FETCH_VENDOR_PERFORMANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default vendorPerformanceReducer;
